import { Modal, ModalBody, ModalContent, ModalHeader } from '@ds';

const MODAL_CLASS_NAMES = {
  wrapper: 'flex-wrap',
  base: 'h-[90vh]',
  body: 'p-0',
};

export type PdfPreviewModalProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  fileName: string;
  signedUrl: string;
};

export const PdfPreviewModal = ({ isOpen, onOpenChange, fileName, signedUrl }: PdfPreviewModalProps) => (
  <Modal isOpen={isOpen} onOpenChange={onOpenChange} size="5xl" classNames={MODAL_CLASS_NAMES}>
    <ModalContent>
      <ModalHeader className="truncate">{fileName}</ModalHeader>
      <ModalBody>
        <iframe src={signedUrl} title={fileName} className="w-full h-full border-0" />
      </ModalBody>
    </ModalContent>
  </Modal>
);
